var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C14.6569 6 16 4.65685 16 3C16 1.34315 14.6569 0 13 0C11.3431 0 10 1.34315 10 3C10 3.55636 10.1514 4.07734 10.4154 4.52398L9.52398 5.41536C9.07734 5.15145 8.55636 5 8 5C7.44364 5 6.92266 5.15145 6.47602 5.41536L5.58464 4.52398C5.84855 4.07734 6 3.55636 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6C3.55636 6 4.07734 5.84855 4.52398 5.58464L5.41536 6.47602C5.15145 6.92266 5 7.44364 5 8C5 8.55636 5.15145 9.07734 5.41536 9.52398L4.52398 10.4154C4.07734 10.1514 3.55636 10 3 10C1.34315 10 0 11.3431 0 13C0 14.6569 1.34315 16 3 16C4.65685 16 6 14.6569 6 13C6 12.4436 5.84855 11.9227 5.58464 11.476L6.47602 10.5846C6.92266 10.8486 7.44364 11 8 11C8.55636 11 9.07734 10.8486 9.52398 10.5846L10.4154 11.476C10.1514 11.9227 10 12.4436 10 13C10 14.6569 11.3431 16 13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10C12.4436 10 11.9227 10.1514 11.476 10.4154L10.5846 9.52398C10.8486 9.07734 11 8.55636 11 8C11 7.44364 10.8486 6.92266 10.5846 6.47602L11.476 5.58464C11.9227 5.84855 12.4436 6 13 6Z",
    fill: "#F5821E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShop);
export default __webpack_public_path__ + "static/media/icon-shop.48489751f5ee11c431c80ceec025b9bb.svg";
export { ForwardRef as ReactComponent };